import {css} from 'lit';
export const styles = css`:host {
  position: relative;
  display: block;
}

slot[name='close-action']::slotted(*) {
  position: absolute;
  top: 8px;
  right: 8px;
}

.xs-btn {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
}

.xs-btn ef-icon {
    font-size: 38px;
  }
`;
export default styles;
